import React from "react";

import { format as formatDate } from "../../../../../utils/date";
import { Card, Row, Col, ToggleButton, Overlay, Popover } from "react-bootstrap";
import Modal from "../../../../../layout/modal";
import Hamburger from "../../../../../layout/kebab";

class InviteModal extends React.Component {
    /**
     *
     */
    constructor() {
        super();
        this.state = {
            invites: {},
            menu: {},
            confirm: {
                show: false
            }
        }
    }

    ifInvited = (uuid, trueValue = true, falseValue = false) => {
        const result = Boolean(this.state.invites[uuid]);
        return result ? trueValue : falseValue;
    }

    onToggleSurvey = (e, uuid) => {
        this.setState(prev => ({
            invites: {
                ...prev.invites,
                [uuid]: !Boolean(prev.invites[uuid])
            }
            
        }))
    }

    openHamburger = (event, surveyUuid) => {
        event.preventDefault();
        this.setState({
            menu: {
                show: true,
                surveyUuid,
                target: event.currentTarget
            }
        });
    }

    closeHamburger = () => {
        this.setState(prev => ({
            menu: {
                ...prev.menu,
                show: false,
                target: null
            }
        }));
    }

    handleAction = async (action, invite) => {
        switch (action) {
            case "review":
                // TODO: route / open a viewer for this invite
                // e.g. this.props.navigate(`/intakes/${invite.uuid}/responses`);
                if (this.props.onReview) this.props.onReview(invite);
                break;
            case "remind":
                if (this.props.onRemind) this.props.onRemind(invite);
                break;
            case "delete":
                this.onConfirmShow({
                    title: "Delete survey request?",
                    body: "Click ok to delete the request and any results received. This does NOT remove any changes that have already been applied.",
                    onOk: () => this.onConfirmDelete(invite)
                });
                break;
            default:
                break;
        }
    
        this.closeHamburger();
    }

    onConfirmShow = (config) => {
        this.setState(prev => ({
            confirm: {
                ...prev.confirm,
                ...config,
                show: true
            }
        }));
    }

    onConfirmHideModal = (e) => {
        this.setState(prev => ({
            confirm: {
                ...prev.confirm,
                show: false
            }
        }));
    }

    onConfirmDelete = (e) => {
        if (this.props.onDelete) this.props.onDelete(e);
        this.onConfirmHideModal();
    }

    onOk = () => {
        if (this.props.onOk) this.props.onOk(this.state.invites);
    }

    onCancel = () => {
        if (this.props.onCancel) this.props.onCancel();
    }

    render() {
        const { menu, invites } = this.state;
        const invitesForSurvey = menu.surveyUuid
            ? this.props.invites?.filter(
                (invite) => invite.surveyUuid === menu.surveyUuid
            )
            : [];
        const hasSelectedSurveys = Object.values(invites).some(Boolean);
        
        return (
            <>
                <Modal show={this.props.show} title="Invite to a Survey" body="Select a survey to send to this person. Once selected, clicking ok causes an email invitation to be sent. You can send multiple surveys at the same time (but it isn't advised). If an invitation has previously been sent, the elipses will allow you to send a reminder or view those results (where available)." buttons={
                    [
                        {
                            caption: "ok",
                            onEnabledClick: this.onOk,
                            variant: "primary",
                            enabled: hasSelectedSurveys,
                            display: true
                        },
                        {
                            default: true,
                            caption: "cancel",
                            onEnabledClick: this.onCancel,
                            variant: "primary",
                            enabled: true,
                            display: true
                        }
                    ]
                }>
                    <Card>
                        <Card.Body className="mb-n2">
                            {this.props.surveys?.map((survey, index) => {
                                const hasInvitesForSurvey = this.props.invites?.some(
                                    (invite) => invite.surveyUuid === survey.uuid
                                );
                                return (
                                    <Row className="g-0 sh-6 mb-2" key={`${survey.uuid}_${index}`}>
                                        <Col>
                                            <div className="d-flex flex-row pt-0 pb-0 ps-3 pe-0 h-100 align-items-center justify-content-between">
                                                <div className="d-flex flex-column">
                                                    <div>{survey.name}</div>
                                                    <div className="text-small text-muted">{survey.description}</div>
                                                </div>
                                                <div className="d-flex">
                                                    <ToggleButton variant={this.ifInvited(survey.uuid, "primary", "outline-primary")}
                                                        size="sm"
                                                        className="ms-1"
                                                        checked={this.ifInvited(survey.uuid)}
                                                        onClick={(e) => this.onToggleSurvey(e, survey.uuid)}>
                                                        {this.ifInvited(survey.uuid, 'Selected', 'Select')}
                                                    </ToggleButton>&nbsp;
                                                    {hasInvitesForSurvey && (
                                                        <>
                                                            &nbsp;
                                                            <Hamburger onClick={(e) => this.openHamburger(e, survey.uuid)} />
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                )
                            })}
                        </Card.Body>
                    </Card>
                </Modal>
                <Overlay
                    target={menu.target}
                    show={menu.show}
                    placement="bottom-end"
                    rootClose
                    onHide={this.closeHamburger}
                >
                    {(props) => (
                        <Popover {...props}>
                           
                            <Popover.Body>
                                {(!invitesForSurvey || !invitesForSurvey.length) && (
                                    <div className="text-muted">No invitations for this survey.</div>
                                )}

                                {invitesForSurvey && invitesForSurvey.map((invite, idx) => {
                                    const label =
                                        invite.name ||
                                        invite.subject ||
                                        `Sent ${formatDate(invite.createdAt)}` ||
                                        `Invitation ${idx + 1}`;

                                    return (
                                        <div key={invite.uuid || idx} className="mb-2">
                                            <div className="fw-bold">{label}</div>
                                            <div className="d-flex flex-row mt-1">
                                                {invite.meta?.data && Object.keys(invite.meta.data).length > 0 ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 me-2 btn-sm small text-start"
                                                        onClick={() => this.handleAction("review", invite)}
                                                    >
                                                        Review
                                                    </button>
                                                ) : ``}
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 me-2 btn-sm small text-start"
                                                    onClick={() => this.handleAction("remind", invite)}
                                                >
                                                    Remind
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 me-2 btn-sm small text-start"
                                                    onClick={() => this.handleAction("delete", invite)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                            {idx < invitesForSurvey.length - 1 && <hr className="my-2" />}
                                        </div>
                                    );
                                })}
                            </Popover.Body>
                        </Popover>
                    )}
                </Overlay>
            </>
        )
    }
}

export default InviteModal;